import $ from 'jquery'
import Swiper from './utils/getSwiper'
import OneTrustAutoSlideHelper from './onetrust-autoslide-helper'
import Dotdotdot from 'dotdotdot-js'

function init () {
  $('.stage-module-js').each(function () {
    initDotdotdot($(this))
  })
  $('.stage-module-adhoc-js').each(function () {
    initAdhocDotdotdot($(this))
  })
  $('.stage-slide-new').each(function () {
    initSliderNew($(this))
  })

  let resizeTimer
  $(window).on('resize', function () {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      if ($(window).innerWidth() >= 1280) {
        // Dotdotdot only for large Viewports
        $('.stage-module-js').each(function () {
          setDotdotdot($(this))
        })
      } else {
        // Dotdotdot destroy and reset styles for small Viewports
        document.querySelectorAll('.content-wrapper .dotdotdot').forEach(el => {
          if (el.__dotdotdotInstance && typeof el.__dotdotdotInstance.destroy === 'function') {
            el.__dotdotdotInstance.destroy()
            delete el.__dotdotdotInstance
          }
          el.style.maxHeight = 'none'
        })
        $('.content-wrapper .copy-text').css('max-height', 'none')
      }
    }, 400)
  })

}

function initSliderNew (element) {
  const $el = element
  const $imageContainer = $el.find('.image-slide-container')
  const $textContainer = $el.find('.text-slide-container')
  const $indicator = $el.find('.slider-indicator-container')
  const autoSlide = $el.data('autoslide')
  const $dot = $indicator.find('.dot')

  const autoplay = (typeof autoSlide !== 'undefined' ? { delay: parseInt(autoSlide) } : false)

  const imageSlider = new Swiper($imageContainer.get(0), {
    loop: true,
    speed: 500,
    autoplay,
    lazy: {
      loadPrevNext: true
    }
  })

  if (autoplay) {
    OneTrustAutoSlideHelper.oneTrustAutoSlideHandler(imageSlider)
  }

  const textSlider = new Swiper($textContainer.get(0), {
    loop: true,
    effect: 'fade',
    autoHeight: true,
    speed: 500,
    breakpoints: {
      576: { autoHeight: true },
      768: { autoHeight: true },
      992: { autoHeight: true },
      1280: { autoHeight: true },
      1920: { autoHeight: true }
    }
  })

  if ($textContainer.length > 0) {
    imageSlider.controller.control = textSlider
    textSlider.controller.control = imageSlider
  }

  imageSlider.on('slideChange', function () {
    $dot.removeClass('active')
    $dot.filter('[data-slider-indicator=' + imageSlider.realIndex + ']').addClass('active')
  })

  $dot.on('click', function () {
    const $this = $(this)
    const index = $this.data('slider-indicator')
    imageSlider.slideToLoop(index)
  })

  $(window).on('resizeend', function () {
    if ($textContainer.length > 0) {
      textSlider.updateAutoHeight()
      textSlider.update()
    }
  })

  $el.find('.slider-arrow').each(function () {
    if ($(this).hasClass('prev')) {
      $(this).on('click', function () {
        imageSlider.slidePrev()
      })
    } else {
      $(this).on('click', function () {
        imageSlider.slideNext()
      })
    }
  })
}

function initDotdotdot (element) {
  $('.content-wrapper .copy-text').css('max-height', 'none')
  setTimeout(function () {
    if ($(window).innerWidth() >= 1280) {
      requestAnimationFrame(() => setDotdotdot(element))
    }
  }, 100)

  $(window).on('resizeend', function () {
    $('.content-wrapper .copy-text').css('max-height', 'none')
    if ($(window).innerWidth() >= 1280) {
      setTimeout(function () {
        setDotdotdot(element)
      }, 500)
    }
  })
}

function initAdhocDotdotdot () {
  document
    .querySelectorAll('.adhoc-container .dotdotdot')
    .forEach(el => {
      const height = el.clientHeight
      const options = {
        height: height,
        watch: false
      }
      el.__dotdotdotInstance = new Dotdotdot(el, options)
    })
}

function setDotdotdot (element) {
  if ($(window).innerWidth() < 1280) return

  let dotdotdotHeight = Infinity

  element.find('.content-wrapper').each(function () {
    const $this = $(this)
    const thisHeight = $this.height()
    const breadcrumbHeight = $this.find('.breadcrumb-container').outerHeight(true)
    const headlineHeight = $this.find('.text-slide-headline-wrapper').outerHeight(true)

    let remainingTextHeight
    if (breadcrumbHeight) {
      remainingTextHeight = thisHeight - (breadcrumbHeight + headlineHeight + 10)
    } else {
      remainingTextHeight = thisHeight - (headlineHeight + 10)
    }

    if (remainingTextHeight < 100) {
      remainingTextHeight = 100
    }

    $this.find('.copy-text').css('max-height', remainingTextHeight + 'px')

    dotdotdotHeight = Math.min(dotdotdotHeight, remainingTextHeight)
  }).promise().done(function () {
    document
      .querySelectorAll('.content-wrapper .dotdotdot')
      .forEach(el => {
        if (el.__dotdotdotInstance && typeof el.__dotdotdotInstance.destroy === 'function') {
          el.__dotdotdotInstance.destroy()
        }

        const options = {
          truncate: 'letter',
          tolerance: 0,
          watch: false,
          height: dotdotdotHeight
        }
        el.__dotdotdotInstance = new Dotdotdot(el, options)
      })
  })
}

export default {
  init
}
